import { render } from "./Vendas.vue?vue&type=template&id=05d5a009&scoped=true"
import script from "./Vendas.vue?vue&type=script&lang=js"
export * from "./Vendas.vue?vue&type=script&lang=js"

import "./Vendas.vue?vue&type=style&index=0&id=05d5a009&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d5a009"]])

export default __exports__